import React from "react";
import st from "./shippingBadge.module.scss";
import { ImgFromCDN } from "@pepdirect/ui/ImgFromCDN";
import { endpoints } from "config";
import { getCloudflareImageSrcSet } from "@pepdirect/helpers/cloudflareImages";

// TODO: Extract to separate component with BundlePromo
export function ShippingBadge(): JSX.Element {
  return (
    <div className={st.wrapper}>
      <figure className={st.imageWrapper}>
        <ImgFromCDN
          srcSetLoader={getCloudflareImageSrcSet}
          cdnDomain={endpoints.cdn}
          src="/static-images/pantry-shop-icons/free-ship-badge.png"
          width={60}
          className={st.image}
        />
      </figure>

      <div className={st.text}>
        <strong>Free Standard Shipping Over $20</strong> on all orders with most
        orders arriving in 2-4 business days.
      </div>
    </div>
  );
}
